import React, { useEffect } from 'react';
import MainContainerLeftControl from '../../universal_components/MainContainerLeftControl/MainContainerLeftControl';
import styles from './PartnersContent/PartnersContent.module.scss';

import { useState } from 'react';
import PartnersAside from './PartnersAside/PartnersAside';
import PartnersItem from './PartnersContent/PartnersItem/PartnersItem';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import SliderPartners from '../../universal_components/SliderPartners/SliderPartners';

const Partners = () => {
  const options = '350px';
  const [activePartner, setActivePartner] = useState(null);
  const partners = useSelector((state) => state.partners.partners);

  const defaultActivePartner = {
    id: 0,
    image: '',
    organization: '',
    name: '',
    tel: '',
    email: '',
    link: '',
  };

  const showNewPartner = (id) => {
    const partner = partners.find((item) => item.id === Number(id));
    setActivePartner(partner || null);
  };

  useEffect(() => {
    if (!partners || partners.length === 0) return;

    // Устанавливаем первого партнера по умолчанию при загрузке данных
    if (!activePartner) {
      showNewPartner(partners[0].id);
    }
  }, [partners]);

  return (
    <div className={styles.partners}>
      <MainContainerLeftControl
        data={activePartner ? <PartnersAside item={activePartner} /> : <PartnersAside item={defaultActivePartner} />}
        widthAside={options}>
        {!isMobile ? (
          <div className={styles.content}>
            <ul>
              {partners &&
                partners.map((item) => (
                  <PartnersItem
                    key={item.id}
                    onClick={() => showNewPartner(item.id)}
                    item={item}
                    isActive={activePartner?.id === item.id}
                  />
                ))}
            </ul>
          </div>
        ) : (
          <div>
            <h3 className={styles.pageTitle}>ПАРТНЕРЫ</h3>
            <SliderPartners array={partners} showNewPartner={showNewPartner} activePartner={activePartner} />
            <PartnersAside item={activePartner || defaultActivePartner} />
          </div>
        )}
      </MainContainerLeftControl>
    </div>
  );
};

export default Partners;
